<template>
  <table class="table">
    <thead>
    <tr>
      <th v-for="column in columns" :style="getColumnStyles(column.styles)" :key="column.key">{{ column.name }}</th>
    </tr>
    </thead>
    <tbody v-if="values.length === 0">
      <tr>
        <td :colspan="columns.length" class="text-center">{{ emptyText }}</td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr v-for="row in values" :key="row.id">
        <td v-for="column in columns" :style="getColumnStyles(column.styles)" :key="column.key">
          <div class="table-row" :class="{clickable, 'inactive': row.active === false}" @click="clickable && row[column.key].length > 0 ? $emit('clicked', row.id) : ''">
            <slot :name="'column_'+ column.key" :data="row">{{ row[column.key] }}</slot>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "List",
  props: {
    values: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: "Keine Einträge"
    }
  },
  methods: {
    getColumnStyles(css) {
      if(!css) return {};
      const styles = {};
      for(const style in css) {
        styles[style] = css[style];
      }
      return styles;
    }
  }
};
</script>

<style lang="scss" scoped>
  td {
    vertical-align: middle;

    .table-row {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;

      &.clickable:hover {
        cursor: pointer;
      }

      &.inactive {
        color: #888;
      }
    }
  }
</style>
